// extracted by mini-css-extract-plugin
module.exports = {"passport_lockup":"PassportLockup_passport_lockup__npl1A","passport_compass_rose_icon":"PassportLockup_passport_compass_rose_icon___uZ5r"};